import React, { useState } from 'react';
import { toast } from 'react-toastify';

import ConfirmModal from 'components/Modals/confirmModal';

export default function CreateWipTestImplModal({ closeModal }) {
  const [creatingNew, setCreatingNew] = useState(false);

  const createWipTestImpl = () => {
    setCreatingNew(true);
    // TODO create new and redirect to it here
    setTimeout(() => setCreatingNew(false), 1000);
    toast.error('Creating WIP Test Implementation Not Implemented!');
  };

  return (
    <ConfirmModal
      title="Confirmation"
      text="Do you want to create a new WIP implementation?"
      onCancel={closeModal}
      onConfirm={createWipTestImpl}
      loading={creatingNew}
    />
  );
}
